import { render, staticRenderFns } from "./OpeningTypeText.vue?vue&type=template&id=a31bce52&scoped=true"
import script from "./OpeningTypeText.vue?vue&type=script&lang=js"
export * from "./OpeningTypeText.vue?vue&type=script&lang=js"
import style0 from "./OpeningTypeText.vue?vue&type=style&index=0&id=a31bce52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31bce52",
  null
  
)

export default component.exports